/* ==========================================================================
   Lovelle — poncho.js
   Loaded only on product.poncho.json, after bra.js (both deferred, in that
   order). bra.js already owns the packs, the per-poncho <select>s, the dots
   it draws over them (data-bra-chips) and the add-to-cart. This file adds:

   1. Real colours on the dots: each <option> carries data-hex from Liquid,
      so a "Kamel" or "Ljusblå" dot is the actual shade, not bra.js's guess.
   2. The name beside each row ("Poncho 1  Ljusgrå") follows its dots.
   3. The swatch block above the packs: one tap puts that colour on every
      poncho in every pack, moves the gallery to its photo, and the block
      follows poncho 1 of the chosen pack when she picks there instead.
   4. Sold-out colours are struck through in both places.

   No user-facing string is written here; every word is already in the DOM.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('.ponchopdp');
  if (!root) return;
  var bundle = root.querySelector('[data-bra-bundle]');
  if (!bundle) return;

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var product = null;
  try { product = JSON.parse(root.querySelector('[data-bra-product-json]').textContent); } catch (e) { product = null; }
  var colorPos = parseInt(bundle.getAttribute('data-color-pos'), 10) || 0;

  /* ---- Which colours are sold out, and which photo belongs to each ---- */
  var soldOut = [];
  var slideOf = {};
  if (product && product.variants && colorPos) {
    var anyAvailable = {};
    product.variants.forEach(function (v) {
      var c = v.options[colorPos - 1];
      if (v.available !== false) anyAvailable[c] = true;
      if (c && slideOf[c] === undefined && v.featured_image && v.featured_image.position) {
        slideOf[c] = v.featured_image.position - 1;
      }
    });
    product.variants.forEach(function (v) {
      var c = v.options[colorPos - 1];
      if (!anyAvailable[c] && soldOut.indexOf(c) < 0) soldOut.push(c);
    });
  }

  var selects = qsa('select[data-bra-color]', bundle);

  /* ---- 1 + 4: paint the dots bra.js drew ---- */
  selects.forEach(function (sel) {
    var chips = sel.parentNode.querySelector('.brachips');
    if (!chips) return;
    qsa('.brachips__opt', chips).forEach(function (btn) {
      var value = btn.getAttribute('data-value');
      var opt = Array.prototype.filter.call(sel.options, function (o) { return o.value === value; })[0];
      var dot = btn.querySelector('.brachips__dot');
      if (opt && dot && opt.getAttribute('data-hex')) dot.style.background = opt.getAttribute('data-hex');
      btn.setAttribute('title', value);
      if (soldOut.indexOf(value) > -1) {
        btn.setAttribute('data-oos', 'true');
        btn.setAttribute('aria-disabled', 'true');
      }
    });
  });

  /* ---- 2: the name beside each row ---- */
  function paintRow(sel) {
    var pick = sel.closest('[data-bra-pick]');
    var name = pick ? pick.querySelector('[data-poncho-pick-name]') : null;
    if (name) name.textContent = sel.value;
  }
  selects.forEach(paintRow);

  /* ---- 3: the swatch block ---- */
  var block = root.querySelector('[data-poncho-color]');
  var swatches = block ? qsa('[data-poncho-swatch]', block) : [];
  var current = block ? block.querySelector('[data-poncho-color-current]') : null;

  swatches.forEach(function (sw) {
    if (soldOut.indexOf(sw.getAttribute('data-value')) > -1) sw.setAttribute('data-oos', 'true');
  });

  function paintBlock(value) {
    swatches.forEach(function (sw) {
      var on = sw.getAttribute('data-value') === value;
      sw.classList.toggle('is-active', on);
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      sw.tabIndex = on ? 0 : -1;
    });
    if (current) current.textContent = value;
  }

  function showPhoto(value) {
    var idx = slideOf[value];
    if (idx === undefined || typeof window.LovelleShowSlide !== 'function') return;
    window.LovelleShowSlide(idx);
    var thumbs = root.querySelector('.brapdp__thumbs');
    if (thumbs && idx > 3) thumbs.classList.remove('is-collapsed');
  }

  function setAll(value) {
    selects.forEach(function (sel) {
      if (sel.__bra) sel.__bra.set(value, true); else sel.value = value;
      paintRow(sel);
    });
    paintBlock(value);
    showPhoto(value);
    if (typeof window.LovelleBraSummary === 'function') window.LovelleBraSummary();
  }

  swatches.forEach(function (sw, i) {
    sw.addEventListener('click', function () {
      if (sw.getAttribute('data-oos') === 'true') return;
      setAll(sw.getAttribute('data-value'));
    });
    sw.addEventListener('keydown', function (e) {
      var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
      if (!step) return;
      e.preventDefault();
      var next = swatches[(i + step + swatches.length) % swatches.length];
      next.focus();
      next.click();
    });
  });

  /* A first colour that is sold out would put an unavailable poncho in
     every row; start on the first one that can be bought instead. */
  if (swatches.length) {
    var first = swatches[0].getAttribute('data-value');
    if (soldOut.indexOf(first) > -1) {
      var ok = swatches.filter(function (s) { return s.getAttribute('data-oos') !== 'true'; })[0];
      if (ok) {
        selects.forEach(function (sel) {
          var v = ok.getAttribute('data-value');
          if (sel.__bra) sel.__bra.set(v, true); else sel.value = v;
          paintRow(sel);
        });
        paintBlock(ok.getAttribute('data-value'));
      }
    } else {
      paintBlock(first);
    }
  }

  /* A colour picked in a row: that row's name follows, and the block above
     follows poncho 1 of whichever pack she is in. bra.js has already moved
     the gallery for this change. */
  bundle.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('select[data-bra-color]')) {
      paintRow(t);
      var pick = t.closest('[data-bra-pick]');
      if (pick && pick.getAttribute('data-index') === '1') paintBlock(t.value);
      return;
    }
    if (t.matches('input[data-bra-tier]')) {
      var box = t.closest('[data-bra-tier-box]');
      var firstSel = box ? box.querySelector('select[data-bra-color]') : null;
      if (firstSel) paintBlock(firstSel.value);
    }
  });
})();
